import emitter from 'tiny-emitter/instance'
export default emitter;
